/** The sentence beside a field a form refused - Q-06. See `useFormChecks` for the pattern.
 *
 * Used as `<FieldError {...checks.say("amount")} />`: the hook hands over the field's name, its
 * sentence (or none) and the id the field points at. Renders nothing when the field is fine.
 * `role="alert"` so a screen reader hears it as it appears, and the field points at it with
 * `aria-describedby` (`FieldProps`), so it is read again when the field takes focus. The colour is the
 * second signal: the first is the words and `aria-invalid`.
 *
 * It takes those three plain values and not the hook's object: that object holds the form's ref, and a
 * ref must not be passed down through render.
 */

import styles from "./FieldError.module.css";

export function FieldError({
  field,
  message,
  id,
}: {
  field: string;
  message: string | undefined;
  id: string;
}) {
  if (!message) return null;
  return (
    <span id={id} className={styles.error} role="alert" data-testid={`field-error-${field}`}>
      {message}
    </span>
  );
}
